import React from 'react'
import { Link } from 'react-router-dom'

const Certificates = () => {
    return (
        <>
            <div className="inner-page-banner-area" style={{ backgroundImage: 'url("/images/About_images/about_banner.jpg")' }}>
                <div className="container">
                    <div className="pagination-area">
                        <h1>Certificate Copy</h1>

                    </div>
                </div>
            </div>


            <div className='gallery-area1'>

                <div className='container'>
                    <h3 className='title-default-center title-bar-counter text-center'>International Level Certificates</h3>
                    <div className='row gallery-wrapper'>
                        <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                            <div className='gallery-box'>
                                <img class="img-responsive" alt="gallery" src='/images/cert-1.jpg' />
                                <div class="gallery-content">
                                    <Link to="/images/cert-1.jpg "
                                        className="zoom"><i class="fa fa-link" aria-hidden="true"></i></Link>
                                </div>
                            </div>
                            <h3>Certificate For Diploma Course</h3>
                        </div>



                        <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                            <div className='gallery-box'>
                                <img class="img-responsive" alt="gallery" src='/images/cert-2.jpg' />
                                <div class="gallery-content">
                                    <Link to="/images/cert-2.jpg "
                                        className="zoom"><i class="fa fa-link" aria-hidden="true"></i></Link>
                                </div>
                            </div>
                            <h3>Certificate For Certificate Course</h3>
                        </div>


                        <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                            <div className='gallery-box'>
                                <img class="img-responsive" alt="gallery" src='/images/cert-3.jpg' />
                                <div class="gallery-content">
                                    <Link to="/images/cert-3.jpg "
                                        className="zoom"><i class="fa fa-link" aria-hidden="true"></i></Link>
                                </div>
                            </div>
                            <h3>Certificate For Technical Course</h3>
                        </div>


                        <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                            <div className='gallery-box'>
                                <img class="img-responsive" alt="gallery" src='/images/cert-4.jpg' />
                                <div class="gallery-content">
                                    <Link to="/images/cert-4.jpg "
                                        className="zoom"><i class="fa fa-link" aria-hidden="true"></i></Link>
                                </div>
                            </div>
                            <h3>Certificate For ATC Registration</h3>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Certificates